<template>
  <div class="flex h-full w-full items-center justify-center">
    <button @click.stop="$emit('toggle')">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="25"
        height="24"
        viewBox="0 0 25 24"
        fill="none"
      >
        <mask
          id="mask0_5952_10941"
          style="mask-type: alpha"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="25"
          height="24"
        >
          <rect
            x="24.5"
            width="24"
            height="24"
            transform="rotate(90 24.5 0)"
            fill="#D9D9D9"
          />
        </mask>
        <g mask="url(#mask0_5952_10941)">
          <path
            d="M4.5 12C4.5 11.45 4.69583 10.9792 5.0875 10.5875C5.47917 10.1958 5.95 10 6.5 10C7.05 10 7.52083 10.1958 7.9125 10.5875C8.30417 10.9792 8.5 11.45 8.5 12C8.5 12.55 8.30417 13.0208 7.9125 13.4125C7.52083 13.8042 7.05 14 6.5 14C5.95 14 5.47917 13.8042 5.0875 13.4125C4.69583 13.0208 4.5 12.55 4.5 12ZM10.5 12C10.5 11.45 10.6958 10.9792 11.0875 10.5875C11.4792 10.1958 11.95 10 12.5 10C13.05 10 13.5208 10.1958 13.9125 10.5875C14.3042 10.9792 14.5 11.45 14.5 12C14.5 12.55 14.3042 13.0208 13.9125 13.4125C13.5208 13.8042 13.05 14 12.5 14C11.95 14 11.4792 13.8042 11.0875 13.4125C10.6958 13.0208 10.5 12.55 10.5 12ZM16.5 12C16.5 11.45 16.6958 10.9792 17.0875 10.5875C17.4792 10.1958 17.95 10 18.5 10C19.05 10 19.5208 10.1958 19.9125 10.5875C20.3042 10.9792 20.5 11.45 20.5 12C20.5 12.55 20.3042 13.0208 19.9125 13.4125C19.5208 13.8042 19.05 14 18.5 14C17.95 14 17.4792 13.8042 17.0875 13.4125C16.6958 13.0208 16.5 12.55 16.5 12Z"
            fill="#27272A"
          />
        </g>
      </svg>
    </button>

    <transition
      enter-active-class="transition-all duration-150 ease-out"
      enter-from-class="opacity-0 scale-95"
      enter-to-class="opacity-100 scale-100"
      leave-active-class="transition-all duration-100 ease-in"
      leave-from-class="opacity-100 scale-100"
      leave-to-class="opacity-0 scale-95"
    >
      <div
        v-if="isOpen"
        class="absolute right-12 top-10 z-50 mt-2 rounded-lg border bg-white shadow-lg"
        data-popup-menu
      >
        <ul class="flex flex-col text-sm text-gray-700">
          <li>
            <button
              @click.stop="$emit('viewNotes', candidateId)"
              class="block w-full cursor-pointer rounded px-3.5 py-2 text-right transition-colors duration-150 hover:bg-gray-100"
            >
              {{ __('View notes') }}
            </button>
          </li>
          <li>
            <button
              @click.stop="$emit('goToResume', candidateId)"
              class="block w-full cursor-pointer rounded px-3.5 py-2 text-right transition-colors duration-150 hover:bg-gray-100"
            >
              {{ __('Go to resume') }}
            </button>
          </li>

          <li :key="candidateId">
            <div class="relative">
              <button
                @mouseenter="showStatusPopup(candidateId)"
                @mouseleave="hideStatusPopup()"
                class="relative z-30 flex w-full cursor-pointer items-center gap-x-2 rounded px-3.5 py-2 transition-colors duration-150 hover:bg-gray-100"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke-width="1.5"
                  stroke="currentColor"
                  class="size-4"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M15.75 19.5 8.25 12l7.5-7.5"
                  />
                </svg>

                <span class="whitespace-nowrap">
                  {{ __('Change status') }}
                </span>
              </button>

              <CandidateChangeStatusPopup
                :candidateId="candidateId"
                :options="options"
                :is-open="hoveredStatusItem === candidateId"
                :is-loading-status="isLoadingStatus"
                :is-loading="isLoading"
                :position-from-end="positionFromEnd"
                @changeStatus="
                  $emit('changeStatus', $event);
                  hideStatusPopup();
                "
                @mouseenter="showStatusPopup(candidateId)"
                @mouseleave="hideStatusPopup()"
                @click.stop="
                  hoveredStatusItem == candidateId
                    ? (hoveredStatusItem = null)
                    : (hoveredStatusItem = candidateId)
                "
              >
                <!-- We have both events on mouseenter,mouseleave and click.stop so that it works on mobile aswell -->
              </CandidateChangeStatusPopup>
            </div>
          </li>

          <li :key="candidateId">
            <div class="relative">
              <button
                @mouseenter="showJobPopup(candidateId)"
                @mouseleave="hideJobPopup()"
                class="relative z-30 flex w-full cursor-pointer items-center justify-between gap-x-2 rounded px-3.5 py-2 transition-colors duration-150 hover:bg-gray-100"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke-width="1.5"
                  stroke="currentColor"
                  class="size-4"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M15.75 19.5 8.25 12l7.5-7.5"
                  />
                </svg>

                <span class="whitespace-nowrap">
                  {{ __('Invite to Job') }}
                </span>
              </button>

              <CandidateInviteToJobPopup
                :candidateId="candidateId"
                :options="jobOptions"
                :is-open="hoveredJobItem === candidateId"
                :position-from-end="positionFromEnd"
                :is-loading-job="isLoadingJob"
                @changeStatus="
                  $emit('inviteToJob', $event);
                  hideJobPopup();
                "
                @mouseenter="showJobPopup(candidateId)"
                @mouseleave="hideJobPopup()"
                @inviteToJob="$emit('inviteToJob', $event)"
                @click.stop="hoveredJobItem == candidateId"
              >
                <!-- We have both events on mouseenter,mouseleave and click.stop so that it works on mobile aswell -->
              </CandidateInviteToJobPopup>
            </div>
          </li>

          <!-- Separator -->
          <div>
            <li>
              <hr class="w-full border-t border-gray-200" />
            </li>

            <li>
              <button
                @click.stop="isDeleteCandidateModalOpen = true"
                class="block w-full cursor-pointer rounded px-3.5 py-2 text-right transition-colors duration-150 hover:bg-gray-100"
              >
                {{ __('Remove') }}
              </button>
            </li>
          </div>
        </ul>
      </div>
    </transition>
  </div>

  <PipelinesCandidateDeleteModal
    v-if="isDeleteCandidateModalOpen"
    :candidateId="candidateId"
    @delete="$emit('delete', $event)"
    @cancel="isDeleteCandidateModalOpen = false"
  >
  </PipelinesCandidateDeleteModal>
</template>

<script setup>
  import { ref } from 'vue';
  import { __ } from '@/helpers';
  import PipelinesCandidateDeleteModal from '../../PipelineShowInfoCard/components/PipelinesCandidateDeleteModal.vue';
  import CandidateChangeStatusPopup from './CandidateChangeStatusPopup.vue';
  import CandidateInviteToJobPopup from './CandidateInviteToJobPopup.vue';
  const isDeleteCandidateModalOpen = ref(false);
  const hoveredStatusItem = ref(null);
  const hoveredJobItem = ref(null);
  defineEmits([
    'toggle',
    'goToResume',
    'changeStatus',
    'viewNotes',
    'delete',
    'inviteToJob'
  ]);

  const props = defineProps({
    status: {
      type: Boolean,
      required: false
    },
    candidateId: {
      type: Number,
      required: false
    },
    isOpen: {
      type: Boolean,
      required: false
    },
    options: {
      type: Object,
      required: false
    },
    isLoading: {
      type: Boolean,
      required: false
    },
    isLoadingStatus: {
      type: Boolean,
      required: false
    },
    jobOptions: {
      type: Object,
      required: false
    },
    positionFromEnd: {
      type: Number,
      required: false
    },
    isLoadingJob: {
      type: Boolean,
      required: false
    }
  });

  const hoverTimeout = ref(null);

  const showStatusPopup = (itemId) => {
    if (hoveredJobItem.value === itemId) {
      hoveredJobItem.value = null;
    }
    clearTimeout(hoverTimeout.value);
    hoveredStatusItem.value = itemId;
  };

  const hideStatusPopup = () => {
    hoverTimeout.value = setTimeout(() => {
      hoveredStatusItem.value = null;
    }, 200);
  };

  const showJobPopup = (itemId) => {
    if (hoveredStatusItem.value === itemId) {
      hoveredStatusItem.value = null;
    }
    clearTimeout(hoverTimeout.value);
    hoveredJobItem.value = itemId;
  };

  const hideJobPopup = () => {
    hoverTimeout.value = setTimeout(() => {
      hoveredJobItem.value = null;
    }, 200);
  };
</script>
